import axios from "@/modules/shared/AxiosInterceptor"
import { EnrichedPlan, Subscription } from "@/types/billingPlans"
import { AxiosResponse } from "axios"

export async function getBillingProducts(): Promise<AxiosResponse<{ items: EnrichedPlan[] }>> {
  try {
    return axios.get("/billing/products")
  } catch (error) {
    throw error
  }
}

export async function getActiveSubscription(): Promise<AxiosResponse<Subscription>> {
  try {
    return axios.get("/billing/subscription")
  } catch (error) {
    throw error
  }
}

export async function postProductRenew(): Promise<AxiosResponse<{}>> {
  try {
    return axios.post("/billing/renew")
  } catch (error) {
    throw error
  }
}
export async function postBillingSubscribe(
  productId: string
): Promise<AxiosResponse<{ product: any }>> {
  try {
    return axios.post("/billing/subscribe", { productId })
  } catch (error) {
    throw error
  }
}

export async function postBillingUnsubscribe(): Promise<AxiosResponse<{ product: any }>> {
  try {
    return axios.post("/billing/unsubscribe")
  } catch (error) {
    throw error
  }
}
